
const filters={
    timeToDate:function(timestamp){
        const date = new Date(timestamp*1000);
        return date.toLocaleString("zh-CN")
    },
    toStatusStyle:function(status){
        const statusMap=["info","primary","success","info","info","info"]
        return statusMap[status]
    },
    toStatusWord:function(status){
        const statusMap=["","已支付","已完成","已取消","未知","未知"]
        return statusMap[status]
    },
    toPaytype:function(paytype){
        const typeMap={"0":"未知","1":"支付宝",'2':"微信","3":'线下(后台)',"4":"线下(上阶确认)"}
        return typeMap[paytype]
    },
    toFahuoWord:function(status){
        const statusMap={0:"未发货",1:"已发货",8:"发货中"}
        return statusMap[status]
    },
    toFahuoStyle:function(status){
        const statusMap={0:"info",1:"success",8:"primary"}
        return statusMap[status]
    },
    toPayoutStatus:function(status){
        const statusMap={0:'未打款',1:"打款中",2:"打款成功",99:"打款失败"}
        return statusMap[status]
    },  
    toPayoutStyle:function(status){
        const statusMap={0:"info",1:"primary",2:"success",99:'danger'}
        return statusMap[status]
    }
}
export default filters